s-dialog {
  display: none;

  &[open]:not([open='false']) {
    border-radius: 12px; // border radius must be set here for the box-shadow
    box-shadow: 0 2px 15px 0 rgba(79, 82, 86, 0.15);
    display: flex;
    flex-direction: column;
    inset-block-end: 50vh;
    inset-inline-end: 50vw;
    max-block-size: 66vh;
    max-inline-size: 66vw;
    min-inline-size: 296px;
    position: fixed;
    -webkit-transform: translate(50%, 50%);
    transform: translate(50%, 50%);
    z-index: 400;

    [data-ref='content-container'] {
      overflow: auto;
    }

    > button[data-ref='dismiss-button'] {
      inset-block-start: 0.875rem;
      inset-inline-end: 0.875rem;
      position: absolute;
      z-index: 1;

      > s-icon {
        color: var(--color-gray-darker);
        font-size: 0.75rem;
      }
    }

    &.overflow-visible [data-ref='content-container'] {
      overflow: visible;
    }

    &::before {
      background: rgba(26, 26, 26, 0.5);
      block-size: 150vh;
      content: ' ';
      display: block;
      inline-size: 150vw;
      inset-block-start: -50vh;
      inset-inline-start: -50vw;
      position: absolute;
    }

    > [slot='header'] {
      align-items: center;
      background-color: var(--color-white);
      border-block-end: 1px solid var(--color-gray-light);
      border-radius: 12px 12px 0 0;
      display: flex;
      font-size: var(--font-size-lg);
      line-height: var(--line-height-md);
      min-block-size: 4.1875rem;
      padding-block: var(--padding-md);
      padding-inline: var(--padding-md) 3.375rem;
    }

    > div:last-child {
      border-radius: 0 0 12px 12px;
    }

    [data-ref='content-container'] {
      background-color: var(--color-white);
      padding: var(--padding-md);
    }

    > [slot='footer'] {
      background-color: var(--color-white);
      border-block-start: 1px solid var(--color-gray-light);
      display: flex;
      justify-content: flex-start;
      padding: var(--padding-md);
    }

    // medium width breakpoint
    @media only screen and (max-width: 839px) {
      max-block-size: 75vh;
    }

    // small width breakpoint
    @media only screen and (max-width: 599px) {
      max-inline-size: 75vw;
    }

    // extra-small width breakpoint
    @media only screen and (max-width: 384px) {
      min-inline-size: 100vw;
      padding-inline: var(--padding-sm);
    }

    /* Fixes IE11 overflow display bug */
    @media (-ms-high-contrast: none), (-ms-high-contrast: active) {
      max-block-size: none;
      [data-ref='content-container'] {
        border: 0;
        max-block-size: 50vh;
      }
      @media only screen and (max-width: 839px) {
        max-block-size: none;
      }
    }
  }
}
